import {
    MANAGERS_ERROR,
    MANAGERS_LOOKUP,
    GET_MANAGERS,
    SET_LOADING,
    MANAGER_ERROR,  
    UPDATE_MANAGER,
    CREATE_MANAGER,
    SET_CURRENT_MANAGER,
    CLEAR_SUCCESS,
    CLEAR_ERRORS,
    DELETE_MANAGER
} from '../types';

const managersReducer = (state, action) => {

    switch (action.type) {
        case SET_LOADING:
            return {
                ...state,
                loading: action.payload
        }       
        case GET_MANAGERS:
            return {
                ...state,
                managers: action.payload.rows,
                count: action.payload.count,
                error: null
            }
        case MANAGERS_LOOKUP:
            return {
                ...state,
                columns: action.payload.gridSettings.managers.columns,
                labels: action.payload.labels,
            }
        case MANAGERS_ERROR:
            return {
                ...state,
                error: action.payload
            }
        case SET_CURRENT_MANAGER:
            return {
                ...state,
                current: action.payload
            }
        case UPDATE_MANAGER:
            const updatedManager = action.payload;
            updatedManager.name = action.payload.first_name + ' ' + action.payload.last_name;
            updatedManager.actions = ["edit", "remove"];
            return {
                ...state,
                managers: state.managers.map(manager => manager.id == action.payload.id ? action.payload : manager),
                current: null,
                success: "המנהל עודכן בהצלחה"
            }
        case CREATE_MANAGER:
            const newManager = action.payload;
            newManager.name = action.payload.first_name + ' ' + action.payload.last_name;
            newManager.actions = ["edit",   "remove"];
            return {
                ...state,
                managers: [newManager, ...state.managers],
                current: null,
                success: "המנהל נוסף בהצלחה"
            }
        case DELETE_MANAGER:
            console.log(action.payload);
            console.log("***");
            return {
                ...state,
                managers: state.managers.filter(manager => manager.id != action.payload.id),
                current: null,
                success: "המנהל נמחק בהצלחה"
            }
        case MANAGER_ERROR:
            console.log(action.payload);
            return {
                ...state,
                error: action.payload
            }
        case CLEAR_SUCCESS:
            return {
                ...state,
                success: "",
            };
        case CLEAR_ERRORS:
            return {
                ...state,
                error: "",
            };
        default:
            return state;
    }
};

export default managersReducer;